export const primarycolor='#27AE60'
